import styled from '@emotion/styled';
import { Link as RLink } from 'react-router-dom';
import setMargin from '../../helpers/set-margin';
import * as T from '../../components/Typography';

export const Container = styled.div`
  position: relative;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const Link = styled(RLink)`
  color: ${({ theme }) => theme.colors.neutralMain};
  display: flex;
`;

export const InnerContainer = styled.div`
  ${setMargin}
  max-width: 932px;
  padding-top: ${({ theme }) => theme.spacings[5]};
  margin-left: auto !important;
  margin-right: auto !important;
  padding-left: ${({ thin, theme }) => (thin ? theme.spacings[6] : 0)};
  padding-right: ${({ thin, theme }) => (thin ? theme.spacings[6] : 0)};
`;

export const SectionHeader = styled.div`
  ${setMargin};
  display: flex;
  align-items: center;
  width: 100%;
`;

export const CloseWrapper = styled.button`
  background: none;
  cursor: pointer;
  border: none;
  z-index: 1000;
  padding: ${({ padding }) => padding};
`;

export const StyledText = styled(T.P)`
  color: ${({ theme: { colors } }) => colors.neutralMain};
  width: 100%;
  text-align: ${({ align }) => `${align}!important` || ''};
`;

export const ResourceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[4]};
`;

export const ResourceWrapper = styled.div`
  width: 100%;
  border-radius: ${({ theme: { borders } }) => borders.radiusLarge};
  background-color: ${({ theme: { colors } }) => colors.primaryLight};
  padding-left: ${({ theme }) => theme.spacings[5]};
  padding-right: ${({ theme }) => theme.spacings[5]};
  padding-top: ${({ theme }) => theme.spacings[4]};
  padding-bottom: ${({ theme }) => theme.spacings[4]};
  margin-bottom: ${({ theme }) => theme.spacings[4]};
`;
